<template lang="pug">
AppDialog#edit-recurring-job-dialog(
  show
  size="smedium"
  has-footer
  append-to-body
  title="Edit recurring job"
  @close="$emit('cancel')"
)
  p Select what you wish to make changes to.
  .d-flex.flex-column.mt-30
    label.d-flex.align-items-center.m-0.mb-10(for="individual")
      input#individual(
        v-model="selected"
        type="radio"
        name="individual"
        :value="false"
        :checked="isIndividualSelected"
      )
      | Just this individual job

    label.d-flex.align-items-center.m-0.mb-10(for="all")
      input#all(
        v-model="selected"
        type="radio"
        name="all"
        value="true"
        :checked="isAllSelected"
      )
      | All occurrences of this job

  template(slot="footer")
    AppButton.mr-15(
      type="danger"
      @click="$emit('cancel')"
    ) Cancel
    AppButton(
      type="primary"
      @click="$emit('confirm', selected)"
    ) Save
</template>

<script>
export default {
  name: 'WorkOrdersEditRecurringJobDialog',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: false,
  }),
  computed: {
    isAllSelected() {
      return !!this.selected;
    },
    isIndividualSelected() {
      return !this.selected;
    },
  },
};
</script>
